import { PlainExtendedMediaStream } from "youm-lib";

export function createEmptyCamMicStream() {
  return new PlainExtendedMediaStream(new MediaStream());
}
